//#region src/components/Map/Root/constants.ts
var e = {
	zoom: 14,
	pitch: 0,
	bearing: 0,
	cooperativeGestures: !1,
	minZoom: 4,
	maxZoom: 17
}, t = {
	maptiler: "600d69cb-288d-445e-9839-3dfe4d76b31a",
	mapbox: "locallogic/cmb9nz9kb011501ru8drq8fqf",
	google: "a7ff20eb973126bb",
	testing: "testing"
}, n = {
	top: 10,
	bottom: 10,
	left: 10,
	right: 10
}, r = [
	-180,
	-85.0511,
	180,
	85.0511
];
//#endregion
export { r as i, t as n, e as r, n as t };
